import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import Image from '../../image/Image';
import { RIGHT_ICON_IMG } from './Data';
import { ColorTokens, ImageSizeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
const RenewalInfo = ({ description1, description2, description3, topMargin }) => {
    return (React.createElement(View, { style: { flexDirection: 'row', marginTop: topMargin } },
        React.createElement(View, { style: { marginRight: 8, alignItems: 'center' } },
            React.createElement(Image, { uri: RIGHT_ICON_IMG, size: ImageSizeTokens.SIZE_16 })),
        React.createElement(Text, null,
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: description1, color: ColorTokens.Grey_Charcoal }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2S, label: description2, color: ColorTokens.Grey_Charcoal }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: description3, color: ColorTokens.Grey_Charcoal }))));
};
const styles = StyleSheet.create({});
export default RenewalInfo;
